
export enum HeaderItemType {
	'Texto' = 1,
	'Número' = 2,
	'Data' = 3,
	'Código de Barras' = 4,
	'Quantidade amostragem' = 6,
	'Lista Dinâmica' = 7,
	'Lista Simples' = 5,
	'Integração Generica' = 8,
}

export enum HeaderItemTypeTranslation {
	'text' = 1,
	'number' = 2,
	'date' = 3,
	'bar_code_or_qr' = 4,
	'sampling_quantity' = 6,
	'dynamic_list' = 7,
	'simple_list' = 5,
	'generic_integration' = 8,
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/header-item-type.ts